(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-reservation-timer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-reservation-timer')) {
    customElements.define('cart-reservation-timer', class extends HTMLElement {
      connectedCallback() {
        if (this.intervalId) return;

        const duration = Math.max(60, Number(this.dataset.duration || 540)) * 1000;
        const storageKey = 'monty-cart-reservation-end';
        let endAt = 0;

        try {
          endAt = Number(sessionStorage.getItem(storageKey) || 0);
        } catch (error) {
          endAt = 0;
        }

        if (!endAt || endAt <= Date.now()) {
          endAt = Date.now() + duration;

          try {
            sessionStorage.setItem(storageKey, String(endAt));
          } catch (error) {
            this.dataset.fallbackEnd = String(endAt);
          }
        }

        this.duration = duration;
        this.endAt = endAt;
        this.renderTime();
        this.intervalId = window.setInterval(() => this.renderTime(), 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) window.clearInterval(this.intervalId);
        this.intervalId = null;
      }

      renderTime() {
        let remaining = this.endAt - Date.now();

        if (remaining <= 0) {
          this.endAt = Date.now() + this.duration;
          remaining = this.duration;

          try {
            sessionStorage.setItem('monty-cart-reservation-end', String(this.endAt));
          } catch (error) {
            this.dataset.fallbackEnd = String(this.endAt);
          }
        }

        const totalSeconds = Math.ceil(remaining / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const minutesNode = this.querySelector('[data-reservation-minutes]');
        const secondsNode = this.querySelector('[data-reservation-seconds]');

        if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
        if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');

      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jewel-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jewel-add-to-cart')) {
    customElements.define(
      'jewel-add-to-cart',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-jewel-atc-button]');
          this.label = this.querySelector('[data-jewel-atc-label]');
          this.formId = this.dataset.formId;
          this.form = document.forms[this.formId];
          this.variantExists = this.dataset.variantExists === 'true';
          this.variantAvailable = this.dataset.variantAvailable === 'true';
          this.selectionComplete = false;
          this.bundleSubmitting = false;

          document.addEventListener('jewel:birthstones-change', this.onBirthstonesChange);
          document.addEventListener('jewel:initial-change', this.onInitialChange);
          document.addEventListener('jewel:offer-builder-change', this.onOfferBuilderChange);
          document.addEventListener('variant:change', this.onVariantChange);
          this.form?.addEventListener('submit', this.onBundleSubmit, true);

          this.syncFromSelectors();
          window.requestAnimationFrame(this.syncFromSelectors);
          this.startShippingTimer();
        }

        disconnectedCallback() {
          document.removeEventListener('jewel:birthstones-change', this.onBirthstonesChange);
          document.removeEventListener('jewel:initial-change', this.onInitialChange);
          document.removeEventListener('jewel:offer-builder-change', this.onOfferBuilderChange);
          document.removeEventListener('variant:change', this.onVariantChange);
          this.form?.removeEventListener('submit', this.onBundleSubmit, true);
          window.clearInterval(this.shippingTimerInterval);
        }

        get labels() {
          return {
            select: this.dataset.labelSelect || 'Select options',
            add: this.dataset.labelAdd || 'Add to cart',
            soldOut: this.dataset.labelSoldOut || 'Sold out',
            unavailable: this.dataset.labelUnavailable || 'Unavailable'
          };
        }

        syncFromSelectors = () => {
          const section = this.closest('.shopify-section') || document;
          const drawer = section.querySelector(
            `jewel-birthstone-drawer[data-form-id="${CSS.escape(this.formId)}"]`
          );
          const initial = section.querySelector(
            `jewel-initial-selector[data-form-id="${CSS.escape(this.formId)}"]`
          );
          const offerBuilder = section.querySelector(
            `jewel-offer-builder[data-form-id="${CSS.escape(this.formId)}"]`
          );
          const drawerComplete = !drawer || drawer.dataset.selectionComplete === 'true';
          const initialComplete = !initial || initial.dataset.selectionComplete === 'true';
          const offerComplete = !offerBuilder || offerBuilder.dataset.selectionComplete === 'true';
          this.offerBuilder = offerBuilder;
          this.selectionComplete = offerBuilder
            ? offerComplete
            : drawerComplete && initialComplete;
          this.renderState();
        };

        onBirthstonesChange = (event) => {
          if (event.detail?.formId !== this.formId) return;
          this.syncFromSelectors();
        };

        onInitialChange = (event) => {
          if (event.detail?.formId !== this.formId) return;
          this.syncFromSelectors();
        };

        onOfferBuilderChange = (event) => {
          if (event.detail?.formId !== this.formId) return;
          this.syncFromSelectors();
        };

        onVariantChange = (event) => {
          if (event.detail?.formId !== this.formId) return;
          this.variantExists = Boolean(event.detail.variant);
          this.variantAvailable = Boolean(event.detail.variant?.available);
          this.renderState();
        };

        onBundleSubmit = (event) => {
          this.syncFromSelectors();
          if (!this.offerBuilder || this.offerBuilder.dataset.addBracelet !== 'true') return;

          event.preventDefault();
          event.stopImmediatePropagation();
          if (!this.selectionComplete || this.bundleSubmitting) return;

          const ringVariantId = Number(this.form?.elements?.id?.value || 0);
          const secondRingVariantId = Number(this.offerBuilder.dataset.secondRingVariantId || 0);
          if (!ringVariantId || !secondRingVariantId) return;

          this.submitBundle(ringVariantId, secondRingVariantId);
        };

        async submitBundle(ringVariantId, secondRingVariantId) {
          const submitButtons = Array.from(this.form.elements).filter((element) => element.type === 'submit');
          submitButtons.forEach((button) => button.setAttribute('aria-busy', 'true'));
          this.bundleSubmitting = true;

          const sections = ['variant-added'];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:prepare-bundled-sections', {
              bubbles: true,
              detail: { sections }
            })
          );

          const bundleId = `monty-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          const ringProperties = { _Bundle: bundleId, _Offer: 'Buy 1 ring, get the 2nd free', _BundleRole: 'Paid ring' };
          const formData = new FormData(this.form);
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== '') ringProperties[match[1]] = value;
          });

          const payload = {
            items: [
              {
                id: ringVariantId,
                quantity: 1,
                properties: ringProperties
              },
              {
                id: secondRingVariantId,
                quantity: 1,
                properties: {
                  _Bundle: bundleId,
                  _Offer: 'Buy 1 ring, get the 2nd free',
                  _BundleRole: 'Free ring',
                  Finish: this.offerBuilder.dataset.secondRingFinish || ''
                }
              }
            ],
            sections,
            sections_url: `${Shopify.routes.root}variants/${ringVariantId}`
          };

          try {
            const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(payload)
            });
            const responseJson = await response.json();

            if (!response.ok) {
              this.form.dispatchEvent(
                new CustomEvent('cart:error', {
                  bubbles: true,
                  detail: { error: responseJson.description || 'Unable to add this offer to cart.' }
                })
              );
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              return;
            }

            if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
              window.location.href = `${Shopify.routes.root}cart`;
              return;
            }

            const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cart.sections = responseJson.sections;
            this.form.dispatchEvent(
              new CustomEvent('variant:add', {
                bubbles: true,
                detail: {
                  items: responseJson.items || [],
                  cart
                }
              })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  cart
                }
              })
            );
          } catch (error) {
            this.form.dispatchEvent(
              new CustomEvent('cart:error', {
                bubbles: true,
                detail: { error: error.message || 'Unable to add this offer to cart.' }
              })
            );
          } finally {
            this.bundleSubmitting = false;
            submitButtons.forEach((button) => button.removeAttribute('aria-busy'));
          }
        }

        renderState() {
          const labels = this.labels;
          let disabled = true;
          let text = labels.select;

          if (this.selectionComplete) {
            if (!this.variantExists) {
              text = labels.unavailable;
            } else if (!this.variantAvailable) {
              text = labels.soldOut;
            } else {
              disabled = false;
              text = this.offerBuilder?.dataset.buttonLabel || labels.add;
            }
          }

          if (this.button) this.button.disabled = disabled;
          if (this.label) this.label.textContent = text;
          this.syncStickyButtons(disabled, text);
        }

        startShippingTimer() {
          const timer = this.form?.querySelector('[data-jewel-shipping-timer]');
          if (!timer) return;
          const duration = 13620;
          const storageKey = 'monty-veria-duo-deadline';
          const render = () => {
            let deadline = Number(window.localStorage.getItem(storageKey) || 0);
            if (!deadline || deadline <= Date.now()) {
              deadline = Date.now() + duration * 1000;
              window.localStorage.setItem(storageKey, String(deadline));
            }
            const remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
            const hours = Math.floor(remaining / 3600);
            const minutes = Math.floor((remaining % 3600) / 60);
            const seconds = remaining % 60;
            timer.textContent = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
          };
          render();
          this.shippingTimerInterval = window.setInterval(render, 1000);
        }

        syncStickyButtons(disabled, text) {
          document
            .querySelectorAll(`product-quick-add[form="${CSS.escape(this.formId)}"] button[type="submit"]`)
            .forEach((button) => {
              button.dataset.jewelAtcLinked = '';
              button.disabled = disabled;
              button.textContent = text;
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jewel-artwork-upload"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jewel-artwork-upload')) {
    customElements.define(
      'jewel-artwork-upload',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('.jewel-artwork-upload__input');
          this.dropzone = this.querySelector('[data-upload-dropzone]');
          this.empty = this.querySelector('[data-upload-empty]');
          this.selected = this.querySelector('[data-upload-selected]');
          this.preview = this.querySelector('[data-upload-preview]');
          this.fileIcon = this.querySelector('[data-upload-file-icon]');
          this.fileName = this.querySelector('[data-upload-file-name]');
          this.footer = this.querySelector('[data-upload-footer]');
          this.removeButton = this.querySelector('[data-upload-remove]');
          this.error = this.querySelector('[data-upload-error]');
          this.objectUrl = null;

          this.input?.addEventListener('change', this.onChange);
          this.removeButton?.addEventListener('click', this.onRemove);
          this.dropzone?.addEventListener('dragenter', this.onDragEnter);
          this.dropzone?.addEventListener('dragover', this.onDragEnter);
          this.dropzone?.addEventListener('dragleave', this.onDragLeave);
          this.dropzone?.addEventListener('drop', this.onDrop);
        }

        disconnectedCallback() {
          this.releasePreview();
        }

        onChange = () => {
          const file = this.input?.files?.[0];
          if (!file) {
            this.renderEmpty();
            return;
          }

          const maxSize = Number(this.dataset.maxSize || 0);
          if (maxSize > 0 && file.size > maxSize) {
            this.input.value = '';
            this.input.setCustomValidity(this.dataset.sizeError || 'This file is too large.');
            this.renderEmpty(this.input.validationMessage);
            this.input.reportValidity();
            return;
          }

          this.input.setCustomValidity('');
          this.renderFile(file);
        };

        onRemove = () => {
          if (!this.input) return;
          this.input.value = '';
          this.input.setCustomValidity('');
          this.renderEmpty();
          this.input.focus();
        };

        onDragEnter = (event) => {
          event.preventDefault();
          this.classList.add('is-dragging');
        };

        onDragLeave = (event) => {
          if (event.relatedTarget && this.dropzone?.contains(event.relatedTarget)) return;
          this.classList.remove('is-dragging');
        };

        onDrop = (event) => {
          event.preventDefault();
          this.classList.remove('is-dragging');
          const file = event.dataTransfer?.files?.[0];
          if (!file || !this.input) return;

          const transfer = new DataTransfer();
          transfer.items.add(file);
          this.input.files = transfer.files;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        };

        renderFile(file) {
          this.releasePreview();
          const isImage = file.type.startsWith('image/') || /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name);

          if (this.fileName) this.fileName.textContent = file.name;
          if (this.empty) this.empty.hidden = true;
          if (this.selected) this.selected.hidden = false;
          if (this.footer) this.footer.hidden = false;
          if (this.error) this.error.hidden = true;

          if (isImage && this.preview) {
            this.objectUrl = URL.createObjectURL(file);
            this.preview.src = this.objectUrl;
            this.preview.hidden = false;
            if (this.fileIcon) this.fileIcon.style.display = 'none';
          } else {
            if (this.preview) {
              this.preview.removeAttribute('src');
              this.preview.hidden = true;
            }
            if (this.fileIcon) this.fileIcon.style.display = 'block';
          }
        }

        renderEmpty(message = '') {
          this.releasePreview();
          if (this.empty) this.empty.hidden = false;
          if (this.selected) this.selected.hidden = true;
          if (this.footer) this.footer.hidden = true;
          if (this.error) {
            this.error.textContent = message;
            this.error.hidden = !message;
          }
        }

        releasePreview() {
          if (!this.objectUrl) return;
          URL.revokeObjectURL(this.objectUrl);
          this.objectUrl = null;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jewel-birthstone-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jewel-birthstone-drawer')) {
    customElements.define(
      'jewel-birthstone-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-jbd-dialog]');
          this.openButton = this.querySelector('[data-jbd-open]');
          this.closeButton = this.querySelector('[data-jbd-close]');
          this.confirmButton = this.querySelector('[data-jbd-confirm]');
          this.closeTimer = null;
          this.activeStep = '1';
          this.selectMonthLabel = this.querySelector('[data-jbd-step-name]')?.textContent || '';
          this.scrollArea = this.querySelector('[data-jbd-scroll]');
          this.scrollHint = this.querySelector('[data-jbd-scroll-hint]');
          this.errorMessage = this.querySelector('[data-jbd-error]');
          this.resizeObserver = new ResizeObserver(this.updateScrollHint);
          if (this.scrollArea) this.resizeObserver.observe(this.scrollArea);
          this.scrollArea?.addEventListener('scroll', this.updateScrollHint, { passive: true });
          this.scrollHint?.addEventListener('click', this.scrollFurther);
          this.addEventListener('keydown', this.switchStepKey);
          this.onSizeChange = (event) => { if (event.detail?.formId === this.dataset.formId) this.updateCounts(); };
          document.addEventListener('jewel:size-change', this.onSizeChange);
          this.selected = {};
          this.requiredCount = Math.max(1, Number(this.dataset.requiredCount) || 2);
          this.restoreSelection();
          this.openButton?.addEventListener('click', this.open);
          this.closeButton?.addEventListener('click', this.close);
          this.confirmButton?.addEventListener('click', this.confirm);
          this.dialog?.addEventListener('cancel', this.cancel);
          this.addEventListener('click', this.selectStone);
        }

        disconnectedCallback() {
          this.openButton?.removeEventListener('click', this.open);
          this.closeButton?.removeEventListener('click', this.close);
          this.confirmButton?.removeEventListener('click', this.confirm);
          this.dialog?.removeEventListener('cancel', this.cancel);
          this.removeEventListener('click', this.selectStone);
          this.resizeObserver?.disconnect();
          this.scrollArea?.removeEventListener('scroll', this.updateScrollHint);
          this.scrollHint?.removeEventListener('click', this.scrollFurther);
          this.removeEventListener('keydown', this.switchStepKey);
          document.removeEventListener('jewel:size-change', this.onSizeChange);
          window.clearTimeout(this.closeTimer);
          document.documentElement.classList.remove('jewel-birthstone-drawer-open');
        }

        open = () => {
          if (!this.dialog || this.dialog.open) return;
          window.clearTimeout(this.closeTimer);
          this.dialog.classList.remove('is-closing');
          this.dialog.showModal();
          this.publishPreview();
          this.showStep(this.selected['1'] && !this.selected['2'] ? '2' : '1');
          this.updateCounts();
          window.requestAnimationFrame(this.updateScrollHint);
          document.documentElement.classList.add('jewel-birthstone-drawer-open');
        };

        close = () => {
          if (!this.dialog?.open || this.dialog.classList.contains('is-closing')) return;
          let finished = false;
          const completeClose = () => {
            if (finished) return;
            finished = true;
            window.clearTimeout(this.closeTimer);
            if (this.dialog.open) this.dialog.close();
            this.dialog.classList.remove('is-closing');
            document.documentElement.classList.remove('jewel-birthstone-drawer-open');
          };
          this.dialog.classList.add('is-closing');
          window.requestAnimationFrame(() => {
            const animations = this.dialog
              .getAnimations({ subtree: true })
              .filter((animation) => animation.playState !== 'finished');
            if (animations.length === 0) return completeClose();
            Promise.allSettled(animations.map((animation) => animation.finished)).then(completeClose);
          });
          this.closeTimer = window.setTimeout(completeClose, 520);
        };

        cancel = (event) => {
          event.preventDefault();
          this.close();
        };

        selectStone = (event) => {
          const step = event.target.closest('[data-jbd-step]');
          if (step) return this.showStep(step.dataset.jbdStep);
          const stone = event.target.closest('[data-jbd-stone]');
          if (!stone) return;
          const optionNumber = stone.dataset.optionNumber;
          this.selected[optionNumber] = stone.dataset.valueId;
          if (this.dataset.directCart === 'true') this.dataset.selectionComplete = 'false';
          if (this.errorMessage) this.errorMessage.hidden = true;
          this.querySelectorAll(`[data-jbd-stone][data-option-number="${optionNumber}"]`).forEach((item) => {
            item.setAttribute('aria-pressed', String(item === stone));
          });
          this.updateCounts();
          this.publishPreview();
          if (this.dataset.directCart === 'true' && optionNumber === '1' && !this.selected['2']) {
            this.showStep('2');
            this.querySelector('[data-jbd-step="2"]')?.focus({ preventScroll: true });
          }
        };

        showStep(number) {
          if (this.dataset.directCart !== 'true') return;
          this.activeStep = number;
          this.querySelectorAll('[data-jbd-step]').forEach((button) => {
            const active = button.dataset.jbdStep === number;
            button.setAttribute('aria-selected', String(active));
            button.tabIndex = active ? 0 : -1;
          });
          this.querySelectorAll('[data-jbd-group]').forEach((group) => { group.hidden = group.dataset.jbdGroup !== number; });
          if (this.scrollArea) this.scrollArea.scrollTop = 0;
          window.requestAnimationFrame(this.updateScrollHint);
        }

        switchStepKey = (event) => {
          if (!event.target.closest('[data-jbd-step]') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const next = this.activeStep === '1' ? '2' : '1';
          this.showStep(next);
          this.querySelector('[data-jbd-step="' + next + '"]')?.focus();
        };

        updateScrollHint = () => {
          if (!this.scrollArea || !this.scrollHint) return;
          this.scrollHint.hidden = this.scrollArea.scrollHeight - this.scrollArea.clientHeight - this.scrollArea.scrollTop < 8;
        };

        scrollFurther = () => {
          this.scrollArea?.scrollBy({ top: 150, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };

        confirm = async () => {
          if (!this.selected['1'] || (this.requiredCount === 2 && !this.selected['2'])) return;
          const firstInput = this.querySelector(
            `[data-option-number="1"][value="${CSS.escape(this.selected['1'])}"]`
          );
          const secondInput = this.requiredCount === 2
            ? this.querySelector(`[data-option-number="2"][value="${CSS.escape(this.selected['2'])}"]`)
            : null;
          if (!firstInput || (this.requiredCount === 2 && !secondInput)) return;
          firstInput.checked = true;
          if (secondInput) secondInput.checked = true;
          this.saveSelection();
          this.dataset.selectionComplete = 'true';
          this.publishSelection();
          if (this.dataset.directCart !== 'true') {
            (secondInput || firstInput).dispatchEvent(new Event('change', { bubbles: true }));
            this.close();
            return;
          }
          const formId = this.dataset.formId;
          const form = document.getElementById(formId);
          const size = (this.closest('.shopify-section') || document).querySelector('jewel-size-selector[data-form-id="' + CSS.escape(formId) + '"]');
          if (size && size.dataset.selectionComplete !== 'true') {
            (secondInput || firstInput).dispatchEvent(new Event('change', { bubbles: true }));
            this.close();
            size.scrollIntoView({ block: 'center', behavior: 'smooth' });
            size.querySelector('input[data-option-position]')?.focus({ preventScroll: true });
            return;
          }
          const controller = this.constructor;
          controller.pendingForms ||= new Set();
          if (!form || controller.pendingForms.has(formId)) return;
          controller.pendingForms.add(formId);
          this.confirmButton.setAttribute('aria-busy', 'true');
          this.confirmButton.disabled = true;
          this.querySelector('[data-jbd-confirm-label]').textContent = this.dataset.labelUpdating;
          let outcomeTimer;
          let cleanupOutcome = () => {};
          try {
            const picker = this.closest('variant-picker') || (this.closest('.shopify-section') || document).querySelector('variant-picker[form-id="' + CSS.escape(formId) + '"]');
            if (!picker?.selectCombination) throw new Error('Variant picker unavailable');
            const optionValues = Array.from(form.elements).filter((input) => input.matches('input[data-option-position]:checked')).sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((input) => input.value);
            await picker.selectCombination({ optionValues, productChange: false });
            const currentForm = document.getElementById(formId);
            const submit = currentForm?.querySelector('[data-jewel-atc-button]');
            if (!submit || submit.disabled || submit.getAttribute('aria-busy') === 'true') throw new Error('Selected variant unavailable');
            const outcome = new Promise((resolve, reject) => {
              const added = () => { cleanupOutcome(); resolve(); };
              const failed = () => { cleanupOutcome(); reject(new Error('Cart error')); };
              cleanupOutcome = () => { window.clearTimeout(outcomeTimer); currentForm.removeEventListener('variant:add', added); currentForm.removeEventListener('cart:error', failed); };
              currentForm.addEventListener('variant:add', added, { once: true });
              currentForm.addEventListener('cart:error', failed, { once: true });
              outcomeTimer = window.setTimeout(() => { cleanupOutcome(); reject(new Error('Cart timeout')); }, 15000);
            });
            this.close();
            currentForm.requestSubmit(submit);
            await outcome;
          } catch (error) {
            cleanupOutcome();
            const activeDrawer = (document.getElementById(formId)?.closest('.shopify-section') || document).querySelector('jewel-birthstone-drawer[data-form-id="' + CSS.escape(formId) + '"]');
            if (activeDrawer?.errorMessage) {
              activeDrawer.errorMessage.textContent = activeDrawer.dataset.labelError;
              activeDrawer.errorMessage.hidden = false;
              activeDrawer.open();
            }
          } finally {
            controller.pendingForms.delete(formId);
            this.confirmButton?.removeAttribute('aria-busy');
            const latestDrawer = (document.getElementById(formId)?.closest('.shopify-section') || document).querySelector('jewel-birthstone-drawer[data-form-id="' + CSS.escape(formId) + '"]');
            latestDrawer?.updateCounts();
          }
        };

        restoreSelection() {
          this.dataset.selectionComplete = 'false';
          try {
            const stored = JSON.parse(sessionStorage.getItem(this.dataset.storageKey) || 'null');
            if (!stored?.one || (this.requiredCount === 2 && !stored?.two)) return this.updateCounts();
            const firstInput = this.querySelector(`[data-option-number="1"][value="${CSS.escape(stored.one)}"]`);
            const secondInput = this.requiredCount === 2
              ? this.querySelector(`[data-option-number="2"][value="${CSS.escape(stored.two)}"]`)
              : null;
            if (!firstInput?.checked || (this.requiredCount === 2 && !secondInput?.checked)) return this.updateCounts();
            this.selected = { '1': stored.one };
            if (this.requiredCount === 2) this.selected['2'] = stored.two;
            this.dataset.selectionComplete = 'true';
            this.querySelector(`[data-jbd-stone][data-option-number="1"][data-value-id="${CSS.escape(stored.one)}"]`)?.setAttribute('aria-pressed', 'true');
            if (this.requiredCount === 2) {
              this.querySelector(`[data-jbd-stone][data-option-number="2"][data-value-id="${CSS.escape(stored.two)}"]`)?.setAttribute('aria-pressed', 'true');
            }
          } catch (error) {
            this.selected = {};
          }
          this.updateCounts();
          queueMicrotask(() => {
            this.publishPreview();
            this.publishSelection();
          });
        }

        publishSelection = () => {
          this.dispatchEvent(
            new CustomEvent('jewel:birthstones-change', {
              bubbles: true,
              detail: {
                formId: this.dataset.formId,
                complete: this.dataset.selectionComplete === 'true',
                one: this.selectedName('1'),
                two: this.selectedName('2')
              }
            })
          );
        };

        publishPreview = () => {
          this.dispatchEvent(
            new CustomEvent('jewel:birthstones-preview', {
              bubbles: true,
              detail: {
                formId: this.dataset.formId,
                one: this.selectedName('1'),
                two: this.selectedName('2')
              }
            })
          );
        };

        selectedName(optionNumber) {
          const valueId = this.selected[optionNumber];
          if (!valueId) return '';
          return this.querySelector(
            `[data-jbd-stone][data-option-number="${optionNumber}"][data-value-id="${CSS.escape(valueId)}"]`
          )?.dataset.stoneName || '';
        }

        saveSelection() {
          try {
            sessionStorage.setItem(
              this.dataset.storageKey,
              JSON.stringify({ one: this.selected['1'], two: this.selected['2'] })
            );
          } catch (error) {
            return;
          }
        }

        updateCounts() {
          const count = Number(Boolean(this.selected['1']))
            + (this.requiredCount === 2 ? Number(Boolean(this.selected['2'])) : 0);
          this.querySelectorAll('[data-jbd-trigger-count], [data-jbd-header-count], [data-jbd-confirm-count]').forEach((item) => {
            item.textContent = `${count}/${this.requiredCount}`;
          });
          this.confirmButton?.setAttribute('aria-disabled', String(count !== this.requiredCount));
          if (this.dataset.directCart === 'true') {
            this.confirmButton.disabled = count !== this.requiredCount || Boolean(this.constructor.pendingForms?.has(this.dataset.formId));
            const size = (this.closest('.shopify-section') || document).querySelector('jewel-size-selector[data-form-id="' + CSS.escape(this.dataset.formId) + '"]');
            this.querySelector('[data-jbd-confirm-label]').textContent = size && size.dataset.selectionComplete !== 'true' ? this.dataset.labelSize : this.dataset.labelAdd;
            this.querySelectorAll('[data-jbd-step-name]').forEach((label) => { label.textContent = this.selectedName(label.dataset.jbdStepName) || this.selectMonthLabel; });
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jewel-color-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jewel-color-selector')) {
    customElements.define(
      'jewel-color-selector',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', (event) => {
            const input = event.target.closest('.jewel-color-selector__input');
            if (!input?.checked) return;

            const label = this.querySelector('[data-jewel-finish-label]');
            if (label) label.textContent = input.dataset.finishLabel || input.value;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jewel-initial-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jewel-initial-selector')) {
    customElements.define(
      'jewel-initial-selector',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.onChange);
          this.sync();
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
        }

        onChange = (event) => {
          if (!event.target.matches('input[name="properties[Letter]"]')) return;
          this.sync();
        };

        sync() {
          const selectedInput = this.querySelector('input[name="properties[Letter]"]:checked');
          const complete = Boolean(selectedInput);
          this.dataset.selectionComplete = complete ? 'true' : 'false';
          document.dispatchEvent(
            new CustomEvent('jewel:initial-change', {
              detail: { formId: this.dataset.formId, complete, letter: selectedInput?.value || '' }
            })
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jewel-offer-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jewel-offer-builder')) {
    customElements.define('jewel-offer-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.formId = this.dataset.formId;
        this.sectionId = this.dataset.sectionId;
        this.form = document.forms[this.formId];
        this.variantPicker = this.closest('variant-picker');
        this.ringSelects = Array.from(this.querySelectorAll('[data-job-ring-select]'));
        this.secondRingSelects = Array.from(this.querySelectorAll('[data-job-bracelet-select]'));
        this.finishButtons = Array.from(this.querySelectorAll('[data-job-bracelet-finish]'));
        this.offerButtons = Array.from(this.querySelectorAll('[data-job-offer-button]'));
        this.secondRingSection = this.querySelector('[data-job-second-ring]');
        this.previewStoneMaps = {};
        this.querySelectorAll('[data-job-preview-stones]').forEach((script) => {
          try { this.previewStoneMaps[script.dataset.jobPreviewStones] = JSON.parse(script.textContent || '{}'); }
          catch (error) { this.previewStoneMaps[script.dataset.jobPreviewStones] = {}; }
        });
        this.visualDropdowns = Array.from(this.querySelectorAll('[data-job-visual-dropdown]'));
        this.visualTriggers = Array.from(this.querySelectorAll('[data-job-visual-trigger]'));
        this.visualOptions = Array.from(this.querySelectorAll('[data-job-visual-option]'));
        this.secondRingFinish = this.dataset.defaultBraceletFinish || 'gold';
        this.offerMode = this.dataset.offerMode || 'duo';
        this.secondRingProducts = {};
        this.ringSyncQueue = Promise.resolve();
        this.ringSyncRevision = 0;
        this.ringVariantPending = false;
        this.ringVariantReady = true;
        this.secondRingRevision = 0;
        this.secondRingVariant = null;
        this.secondRingPending = false;

        this.querySelectorAll('[data-job-bracelet-product]').forEach((script) => {
          try { this.secondRingProducts[script.dataset.jobBraceletProduct] = JSON.parse(script.textContent || 'null'); }
          catch (error) { this.secondRingProducts[script.dataset.jobBraceletProduct] = null; }
        });

        this.ringSelects.forEach((select) => select.addEventListener('change', this.onRingChange));
        this.secondRingSelects.forEach((select) => select.addEventListener('change', this.onSecondRingChange));
        this.finishButtons.forEach((button) => button.addEventListener('click', this.onFinishChange));
        this.offerButtons.forEach((button) => button.addEventListener('click', this.onOfferChange));
        this.visualTriggers.forEach((button) => button.addEventListener('click', this.onVisualTrigger));
        this.visualOptions.forEach((button) => button.addEventListener('click', this.onVisualOption));
        document.addEventListener('click', this.onOutsideClick);
        document.addEventListener('keydown', this.onDocumentKeydown);

        this.dialog = this.querySelector('[data-job-size-guide-dialog]');
        this.querySelectorAll('[data-job-size-guide-open]').forEach((button) => button.addEventListener('click', this.openGuide));
        this.querySelector('[data-job-size-guide-close]')?.addEventListener('click', this.closeGuide);
        this.dialog?.addEventListener('click', this.onGuideBackdrop);
        this.applyOfferMode();
        this.updateSecondPreviewFinish();
        this.startOfferTimer();
        this.updateState();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutsideClick);
        document.removeEventListener('keydown', this.onDocumentKeydown);
        window.clearInterval(this.offerTimerInterval);
      }

      onOfferChange = (event) => {
        this.offerMode = event.currentTarget.dataset.jobOfferButton || 'duo';
        this.applyOfferMode();
        if (this.offerMode === 'duo') this.queueSecondRingVariant();
        this.updateState();
      };

      applyOfferMode() {
        const duo = this.offerMode === 'duo';
        this.dataset.offerMode = this.offerMode;
        this.dataset.addBracelet = String(duo && this.dataset.addSecondEnabled === 'true');
        this.offerButtons.forEach((button) => {
          const selected = button.dataset.jobOfferButton === this.offerMode;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', String(selected));
        });
        if (this.secondRingSection) this.secondRingSection.hidden = !duo;
        const property = this.querySelector('[data-job-offer-property]');
        if (property) property.value = duo ? 'Buy 1 ring, get the 2nd free' : 'Single Veria ring';
      }

      onRingChange = (event) => {
        const select = event.currentTarget;
        if (!select.value || !this.form) return this.updateState();
        const input = Array.from(this.form.elements).find((element) => element.matches?.('[data-job-ring-input]') && element.dataset.optionPosition === select.dataset.optionPosition && element.value === select.value);
        if (input) {
          input.checked = true;
          this.publishRingSelection();
          const optionValues = Array.from(this.form.elements).filter((element) => element.matches?.('[data-job-ring-input]:checked')).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((element) => element.value);
          const revision = ++this.ringSyncRevision;
          this.ringVariantPending = true;
          this.ringVariantReady = false;
          this.ringSyncQueue = this.ringSyncQueue.then(() => this.syncRingVariant(optionValues, input, revision)).catch(() => {
            if (revision === this.ringSyncRevision) { this.ringVariantPending = false; this.ringVariantReady = false; this.updateState(); }
          });
        }
        this.updateState();
      };

      syncRingVariant = async (optionValues, fallbackInput, revision) => {
        if (typeof this.variantPicker?.selectCombination === 'function') await this.variantPicker.selectCombination({ optionValues, productChange: false });
        else fallbackInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (revision === this.ringSyncRevision) { this.ringVariantPending = false; this.ringVariantReady = true; this.updateState(); }
      };

      publishRingSelection() {
        const one = this.querySelector('[data-job-ring-stone="one"]');
        const two = this.querySelector('[data-job-ring-stone="two"]');
        const oneName = one?.value ? one.selectedOptions[0]?.textContent?.trim() || '' : '';
        const twoName = two?.value ? two.selectedOptions[0]?.textContent?.trim() || '' : '';
        this.updateOfferPreviews('ring', oneName, twoName);
        if (!oneName && !twoName) return;
        this.dispatchEvent(new CustomEvent('jewel:birthstones-change', { bubbles: true, detail: { formId: this.formId, complete: Boolean(oneName && twoName), one: oneName, two: twoName } }));
      }

      publishSecondRingSelection() {
        const [one, two] = this.secondRingSelects.filter((select) => select.closest('.jewel-offer-builder__stone-grid'));
        const oneName = one?.value ? one.selectedOptions[0]?.textContent?.trim() || '' : '';
        const twoName = two?.value ? two.selectedOptions[0]?.textContent?.trim() || '' : '';
        this.updateOfferPreviews('second', oneName, twoName);
      }

      normalizePreviewValue(value) { return String(value || '').trim().toLowerCase(); }

      updateOfferPreviews(source, one, two) {
        const left = this.normalizePreviewValue(one);
        const right = this.normalizePreviewValue(two);
        this.querySelectorAll(`[data-job-offer-preview="${source}"]`).forEach((preview) => {
          const map = this.previewStoneMaps[preview.dataset.previewFinish] || {};
          if (left) this.applyPreviewStone(preview.querySelector('[data-job-preview-stone="left"]'), 'left', map[left]);
          if (right) this.applyPreviewStone(preview.querySelector('[data-job-preview-stone="right"]'), 'right', map[right]);
        });
      }

      applyPreviewStone(image, targetSide, stone) {
        if (!image || !stone?.url) return;
        image.src = stone.url;
        image.style.filter = stone.filter || 'none';
        image.classList.toggle('is-mirrored', stone.sourceSide !== targetSide);
        image.hidden = false;
      }

      updateSecondPreviewFinish() {
        this.querySelectorAll('[data-job-offer-preview="second"]').forEach((preview) => {
          preview.hidden = preview.dataset.previewFinish !== this.secondRingFinish;
        });
      }

      onSecondRingChange = () => { this.publishSecondRingSelection(); this.queueSecondRingVariant(); this.updateState(); };

      onFinishChange = (event) => {
        const button = event.currentTarget;
        this.secondRingFinish = button.dataset.jobBraceletFinish;
        this.finishButtons.forEach((item) => { const selected = item === button; item.classList.toggle('is-selected', selected); item.setAttribute('aria-pressed', String(selected)); });
        const label = this.querySelector('[data-job-bracelet-finish-name]');
        if (label) label.textContent = button.getAttribute('aria-label') || this.secondRingFinish;
        this.updateSecondPreviewFinish();
        this.queueSecondRingVariant();
        this.updateState();
      };

      queueSecondRingVariant() {
        if (this.offerMode !== 'duo') return;
        if (!this.secondRingSelects.length || this.secondRingSelects.some((select) => !select.value)) { this.secondRingVariant = null; this.secondRingPending = false; return; }
        const secondProduct = this.secondRingProducts[this.secondRingFinish];
        if (!secondProduct) { this.secondRingVariant = null; return; }
        const requested = new Map(this.secondRingSelects.map((select) => [select.dataset.optionName, select.value]));
        const optionValueIds = secondProduct.options.map((option) => option.values.find((value) => value.name === requested.get(option.name))?.id);
        if (optionValueIds.some((value) => !value)) { this.secondRingVariant = null; return; }
        const revision = ++this.secondRingRevision;
        this.secondRingPending = true;
        this.secondRingVariant = null;
        this.updateState();
        this.resolveSecondRingVariant(secondProduct, optionValueIds, revision);
      }

      async resolveSecondRingVariant(secondProduct, optionValueIds, revision) {
        try {
          const separator = secondProduct.url.includes('?') ? '&' : '?';
          const url = `${secondProduct.url}${separator}option_values=${optionValueIds.join(',')}&section_id=${encodeURIComponent(this.sectionId)}`;
          const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('Variant resolution failed');
          const fragment = document.createRange().createContextualFragment(await response.text());
          const variant = JSON.parse(fragment.querySelector('variant-picker script[data-variant]')?.textContent || '{}');
          if (revision !== this.secondRingRevision) return;
          this.secondRingVariant = variant?.id ? variant : null;
        } catch (error) {
          if (revision === this.secondRingRevision) this.secondRingVariant = null;
        } finally {
          if (revision === this.secondRingRevision) { this.secondRingPending = false; this.updateState(); }
        }
      }

      onVisualTrigger = (event) => {
        const dropdown = event.currentTarget.closest('[data-job-visual-dropdown]');
        const willOpen = event.currentTarget.getAttribute('aria-expanded') !== 'true';
        this.closeVisualDropdowns(dropdown);
        event.currentTarget.setAttribute('aria-expanded', String(willOpen));
        const menu = dropdown?.querySelector('[data-job-visual-menu]');
        if (menu) menu.hidden = !willOpen;
      };

      onVisualOption = (event) => {
        const option = event.currentTarget;
        const dropdown = option.closest('[data-job-visual-dropdown]');
        const select = dropdown?.querySelector('[data-job-visual-select]');
        if (!select || !option.dataset.value) return;
        select.value = option.dataset.value;
        dropdown.querySelectorAll('[data-job-visual-option]').forEach((item) => item.setAttribute('aria-selected', String(item === option)));
        const label = dropdown.querySelector('[data-job-selected-label]');
        if (label) label.textContent = option.dataset.label || '';
        const swatch = dropdown.querySelector('[data-job-selected-swatch]');
        if (swatch) {
          const imageUrl = option.dataset.imageUrl || '';
          swatch.style.backgroundImage = imageUrl ? `url(${JSON.stringify(imageUrl)})` : '';
          swatch.style.setProperty('--job-stone-color', option.dataset.stoneColor || '#8D1821');
          swatch.classList.toggle('jewel-offer-builder__stone-swatch--fallback', !imageUrl);
          swatch.hidden = false;
        }
        this.closeVisualDropdowns();
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };

      onOutsideClick = (event) => { if (!this.contains(event.target)) this.closeVisualDropdowns(); };
      onDocumentKeydown = (event) => { if (event.key === 'Escape') this.closeVisualDropdowns(); };
      closeVisualDropdowns(except = null) {
        this.visualDropdowns.forEach((dropdown) => {
          if (dropdown === except) return;
          dropdown.querySelector('[data-job-visual-trigger]')?.setAttribute('aria-expanded', 'false');
          const menu = dropdown.querySelector('[data-job-visual-menu]');
          if (menu) menu.hidden = true;
        });
      }

      updateState() {
        const ringComplete = this.ringSelects.length > 0 && this.ringSelects.every((select) => Boolean(select.value));
        const duo = this.offerMode === 'duo';
        const secondComplete = this.secondRingSelects.length > 0 && this.secondRingSelects.every((select) => Boolean(select.value));
        const secondReady = !duo || (secondComplete && !this.secondRingPending && Boolean(this.secondRingVariant?.available));
        const complete = ringComplete && this.ringVariantReady && !this.ringVariantPending && secondReady;
        this.dataset.selectionComplete = String(complete);
        this.dataset.addBracelet = String(duo && this.dataset.addSecondEnabled === 'true');
        this.dataset.braceletVariantId = this.secondRingVariant?.id || '';
        this.dataset.secondRingVariantId = this.secondRingVariant?.id || '';
        this.dataset.braceletFinish = this.secondRingFinish;
        this.dataset.secondRingFinish = this.secondRingFinish;
        this.dataset.buttonLabel = duo ? `Add the duo to cart — ${this.dataset.offerPrice}` : `Add to cart — ${this.dataset.offerPrice}`;
        const property = this.querySelector('[data-job-bracelet-variant-property]');
        if (property) property.value = this.secondRingVariant?.id || '';
        this.dispatchEvent(new CustomEvent('jewel:offer-builder-change', { bubbles: true, detail: { formId: this.formId, complete, offerMode: this.offerMode, buttonLabel: this.dataset.buttonLabel, secondRingVariantId: this.secondRingVariant?.id || null, secondRingFinish: this.secondRingFinish } }));
      }

      startOfferTimer() {
        const duration = Math.max(60, Number(this.dataset.offerSeconds || 13620));
        const storageKey = 'monty-veria-duo-deadline';
        let deadline = Number(window.localStorage.getItem(storageKey) || 0);
        if (!deadline || deadline <= Date.now()) { deadline = Date.now() + duration * 1000; window.localStorage.setItem(storageKey, String(deadline)); }
        const render = () => {
          let remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
          if (remaining <= 0) { deadline = Date.now() + duration * 1000; window.localStorage.setItem(storageKey, String(deadline)); remaining = duration; }
          const hours = Math.floor(remaining / 3600);
          const minutes = Math.floor((remaining % 3600) / 60);
          const seconds = remaining % 60;
          const text = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
          this.querySelectorAll('[data-job-offer-timer]').forEach((element) => { element.textContent = text; });
        };
        render();
        this.offerTimerInterval = window.setInterval(render, 1000);
      }

      openGuide = () => this.dialog?.showModal();
      closeGuide = () => this.dialog?.close();
      onGuideBackdrop = (event) => { if (event.target === this.dialog) this.dialog.close(); };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jewel-set-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jewel-set-add-to-cart')) {
    customElements.define(
      'jewel-set-add-to-cart',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-jewel-atc-button]');
          this.label = this.querySelector('[data-jewel-atc-label]');
          this.formId = this.dataset.formId;
          this.form = document.forms[this.formId];
          this.variantExists = this.dataset.variantExists === 'true';
          this.variantAvailable = this.dataset.variantAvailable === 'true';
          this.selectionComplete = false;
          this.bundleSubmitting = false;

          document.addEventListener('jewel:size-change', this.onBirthstonesChange);
          document.addEventListener('jewel:birthstones-change', this.onBirthstonesChange);
          document.addEventListener('jewel:initial-change', this.onInitialChange);
          document.addEventListener('jewel:offer-builder-change', this.onOfferBuilderChange);
          document.addEventListener('variant:change', this.onVariantChange);
          this.form?.addEventListener('submit', this.onBundleSubmit, true);

          this.syncFromSelectors();
          window.requestAnimationFrame(this.syncFromSelectors);
          this.startShippingTimer();
        }

        disconnectedCallback() {
          document.removeEventListener('jewel:size-change', this.onBirthstonesChange);
          document.removeEventListener('jewel:birthstones-change', this.onBirthstonesChange);
          document.removeEventListener('jewel:initial-change', this.onInitialChange);
          document.removeEventListener('jewel:offer-builder-change', this.onOfferBuilderChange);
          document.removeEventListener('variant:change', this.onVariantChange);
          this.form?.removeEventListener('submit', this.onBundleSubmit, true);
          window.clearInterval(this.shippingTimerInterval);
        }

        get labels() {
          return {
            size: this.dataset.labelSize,
            updating: this.dataset.labelUpdating,
            select: this.dataset.labelSelect || 'Select options',
            add: this.dataset.labelAdd || 'Add to cart',
            soldOut: this.dataset.labelSoldOut || 'Sold out',
            unavailable: this.dataset.labelUnavailable || 'Unavailable'
          };
        }

        syncFromSelectors = () => {
          const section = this.closest('.shopify-section') || document;
          const drawer = section.querySelector(
            `jewel-birthstone-drawer[data-form-id="${CSS.escape(this.formId)}"]`
          );
          const initial = section.querySelector(
            `jewel-initial-selector[data-form-id="${CSS.escape(this.formId)}"]`
          );
          const offerBuilder = section.querySelector(
            `jewel-set-offer[data-form-id="${CSS.escape(this.formId)}"]`
          );
          this.sizeSelector = section.querySelector(
            `jewel-size-selector[data-form-id="${CSS.escape(this.formId)}"]`
          );
          this.sizeComplete = !this.sizeSelector || this.sizeSelector.dataset.selectionComplete === 'true';
          const drawerComplete = !drawer || drawer.dataset.selectionComplete === 'true';
          const initialComplete = !initial || initial.dataset.selectionComplete === 'true';
          const offerComplete = !offerBuilder || offerBuilder.dataset.selectionComplete === 'true';
          this.offerBuilder = offerBuilder;
          this.selectionComplete = this.sizeComplete && (offerBuilder
            ? offerComplete
            : drawerComplete && initialComplete);
          this.renderState();
        };

        onBirthstonesChange = (event) => {
          if (event.detail?.formId !== this.formId) return;
          this.syncFromSelectors();
        };

        onInitialChange = (event) => {
          if (event.detail?.formId !== this.formId) return;
          this.syncFromSelectors();
        };

        onOfferBuilderChange = (event) => {
          if (event.detail?.formId !== this.formId) return;
          this.syncFromSelectors();
        };

        onVariantChange = (event) => {
          if (event.detail?.formId !== this.formId) return;
          this.variantExists = Boolean(event.detail.variant);
          this.variantAvailable = Boolean(event.detail.variant?.available);
          this.syncFromSelectors();
        };

        onBundleSubmit = (event) => {
          this.syncFromSelectors();
          if (!this.sizeComplete) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.sizeSelector?.querySelector('input[data-option-position]')?.focus();
            return;
          }
          if (!this.offerBuilder || this.offerBuilder.dataset.addBracelet !== 'true') return;

          event.preventDefault();
          event.stopImmediatePropagation();
          if (!this.selectionComplete || this.bundleSubmitting) return;

          const ringVariantId = Number(this.form?.elements?.id?.value || 0);
          const secondRingVariantId = Number(this.offerBuilder.dataset.secondRingVariantId || 0);
          if (!ringVariantId || !secondRingVariantId) return;

          this.submitBundle(ringVariantId, secondRingVariantId);
        };

        async submitBundle(ringVariantId, secondRingVariantId) {
          const submitButtons = Array.from(this.form.elements).filter((element) => element.type === 'submit');
          submitButtons.forEach((button) => button.setAttribute('aria-busy', 'true'));
          this.bundleSubmitting = true;

          const sections = ['variant-added'];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:prepare-bundled-sections', {
              bubbles: true,
              detail: { sections }
            })
          );

          const bundleId = `monty-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          const ringProperties = { _Bundle: bundleId, _Offer: 'Buy 1 ring, get the matching bracelet free', _BundleRole: 'Paid ring' };
          const formData = new FormData(this.form);
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== '') ringProperties[match[1]] = value;
          });

          const payload = {
            items: [
              {
                id: ringVariantId,
                quantity: 1,
                properties: ringProperties
              },
              {
                id: secondRingVariantId,
                quantity: 1,
                properties: {
                  _Bundle: bundleId,
                  _Offer: 'Buy 1 ring, get the matching bracelet free',
                  _BundleRole: 'Free bracelet',
                  Finish: this.offerBuilder.dataset.secondRingFinish || ''
                }
              }
            ],
            sections,
            sections_url: `${Shopify.routes.root}variants/${ringVariantId}`
          };

          try {
            const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(payload)
            });
            const responseJson = await response.json();

            if (!response.ok) {
              this.form.dispatchEvent(
                new CustomEvent('cart:error', {
                  bubbles: true,
                  detail: { error: responseJson.description || 'Unable to add this offer to cart.' }
                })
              );
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              return;
            }

            if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
              window.location.href = `${Shopify.routes.root}cart`;
              return;
            }

            const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cart.sections = responseJson.sections;
            this.form.dispatchEvent(
              new CustomEvent('variant:add', {
                bubbles: true,
                detail: {
                  items: responseJson.items || [],
                  cart
                }
              })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  cart
                }
              })
            );
          } catch (error) {
            this.form.dispatchEvent(
              new CustomEvent('cart:error', {
                bubbles: true,
                detail: { error: error.message || 'Unable to add this offer to cart.' }
              })
            );
          } finally {
            this.bundleSubmitting = false;
            submitButtons.forEach((button) => button.removeAttribute('aria-busy'));
          }
        }

        renderState() {
          const labels = this.labels;
          let disabled = true;
          let text = this.sizeComplete ? labels.select
            : this.sizeSelector?.dataset.selectionPending === 'true' ? labels.updating : labels.size;

          if (this.selectionComplete) {
            if (!this.variantExists) {
              text = labels.unavailable;
            } else if (!this.variantAvailable) {
              text = labels.soldOut;
            } else {
              disabled = false;
              text = this.offerBuilder?.dataset.buttonLabel || labels.add;
            }
          }

          if (this.button) this.button.disabled = disabled;
          if (this.label) this.label.textContent = text;
          this.syncStickyButtons(disabled, text);
        }

        startShippingTimer() {
          const timer = this.form?.querySelector('[data-jewel-shipping-timer]');
          if (!timer) return;
          const duration = 13620;
          const storageKey = 'monty-veria-duo-deadline';
          const render = () => {
            let deadline = Number(window.localStorage.getItem(storageKey) || 0);
            if (!deadline || deadline <= Date.now()) {
              deadline = Date.now() + duration * 1000;
              window.localStorage.setItem(storageKey, String(deadline));
            }
            const remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
            const hours = Math.floor(remaining / 3600);
            const minutes = Math.floor((remaining % 3600) / 60);
            const seconds = remaining % 60;
            timer.textContent = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
          };
          render();
          this.shippingTimerInterval = window.setInterval(render, 1000);
        }

        syncStickyButtons(disabled, text) {
          document
            .querySelectorAll(`product-quick-add[form="${CSS.escape(this.formId)}"] button[type="submit"]`)
            .forEach((button) => {
              button.dataset.jewelAtcLinked = '';
              button.disabled = disabled;
              button.textContent = text;
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jewel-set-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jewel-set-offer')) {
    customElements.define('jewel-set-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.formId = this.dataset.formId;
        this.sectionId = this.dataset.sectionId;
        this.form = document.forms[this.formId];
        this.variantPicker = this.closest('variant-picker');
        this.ringSelects = Array.from(this.querySelectorAll('[data-job-ring-select]'));
        this.secondRingSelects = Array.from(this.querySelectorAll('[data-job-bracelet-select]'));
        this.finishButtons = Array.from(this.querySelectorAll('[data-job-bracelet-finish]'));
        this.offerButtons = Array.from(this.querySelectorAll('[data-job-offer-button]'));
        this.secondRingSection = this.querySelector('[data-job-second-ring]');
        this.previewStoneMaps = {};
        this.querySelectorAll('[data-job-preview-stones]').forEach((script) => {
          try { this.previewStoneMaps[script.dataset.jobPreviewStones] = JSON.parse(script.textContent || '{}'); }
          catch (error) { this.previewStoneMaps[script.dataset.jobPreviewStones] = {}; }
        });
        this.visualDropdowns = Array.from(this.querySelectorAll('[data-job-visual-dropdown]'));
        this.visualTriggers = Array.from(this.querySelectorAll('[data-job-visual-trigger]'));
        this.visualOptions = Array.from(this.querySelectorAll('[data-job-visual-option]'));
        this.secondRingFinish = this.dataset.defaultBraceletFinish || 'gold';
        this.offerMode = this.dataset.addSecondEnabled === 'true' ? (this.dataset.offerMode || 'duo') : 'single';
        this.secondRingProducts = {};
        this.ringSyncQueue = Promise.resolve();
        this.ringSyncRevision = 0;
        this.ringVariantPending = false;
        this.ringVariantReady = true;
        this.secondRingRevision = 0;
        this.secondRingVariant = null;
        this.secondRingPending = false;

        this.querySelectorAll('[data-job-bracelet-product]').forEach((script) => {
          try { this.secondRingProducts[script.dataset.jobBraceletProduct] = JSON.parse(script.textContent || 'null'); }
          catch (error) { this.secondRingProducts[script.dataset.jobBraceletProduct] = null; }
        });

        this.ringSelects.forEach((select) => select.addEventListener('change', this.onRingChange));
        this.secondRingSelects.forEach((select) => select.addEventListener('change', this.onSecondRingChange));
        this.finishButtons.forEach((button) => button.addEventListener('click', this.onFinishChange));
        this.offerButtons.forEach((button) => button.addEventListener('click', this.onOfferChange));
        this.visualTriggers.forEach((button) => button.addEventListener('click', this.onVisualTrigger));
        this.visualOptions.forEach((button) => button.addEventListener('click', this.onVisualOption));
        document.addEventListener('click', this.onOutsideClick);
        document.addEventListener('keydown', this.onDocumentKeydown);

        this.dialog = this.querySelector('[data-job-size-guide-dialog]');
        this.querySelectorAll('[data-job-size-guide-open]').forEach((button) => button.addEventListener('click', this.openGuide));
        this.querySelector('[data-job-size-guide-close]')?.addEventListener('click', this.closeGuide);
        this.dialog?.addEventListener('click', this.onGuideBackdrop);
        this.giftVariants = {};
        this.querySelectorAll('[data-job-gift-variants]').forEach(script => { this.giftVariants[script.dataset.jobGiftVariants] = JSON.parse(script.textContent || '[]'); });
        this.applyOfferMode();
        this.updateSecondPreviewFinish();
        if (this.dataset.addSecondEnabled === 'true') this.startOfferTimer();
        this.updateState();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutsideClick);
        document.removeEventListener('keydown', this.onDocumentKeydown);
        window.clearInterval(this.offerTimerInterval);
      }

      onOfferChange = (event) => {
        this.offerMode = event.currentTarget.dataset.jobOfferButton || 'duo';
        this.applyOfferMode();
        if (this.offerMode === 'duo') this.queueSecondRingVariant();
        this.updateState();
      };

      applyOfferMode() {
        if (this.dataset.addSecondEnabled !== 'true') this.offerMode = 'single';
        const duo = this.offerMode === 'duo';
        this.dataset.offerMode = this.offerMode;
        this.dataset.addBracelet = String(duo && this.dataset.addSecondEnabled === 'true');
        this.offerButtons.forEach((button) => {
          const selected = button.dataset.jobOfferButton === this.offerMode;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', String(selected));
        });
        if (this.secondRingSection) this.secondRingSection.hidden = !duo;
        const property = this.querySelector('[data-job-offer-property]');
        if (property) property.value = duo ? 'Buy 1 ring, get the matching bracelet free' : 'Single Veria ring';
      }

      onRingChange = (event) => {
        const select = event.currentTarget;
        if (!select.value || !this.form) return this.updateState();
        const input = Array.from(this.form.elements).find((element) => element.matches?.('[data-job-ring-input]') && element.dataset.optionPosition === select.dataset.optionPosition && element.value === select.value);
        if (input) {
          input.checked = true;
          this.publishRingSelection();
          const optionValues = Array.from(this.form.elements).filter((element) => element.matches?.('[data-job-ring-input]:checked')).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((element) => element.value);
          const revision = ++this.ringSyncRevision;
          this.ringVariantPending = true;
          this.ringVariantReady = false;
          this.ringSyncQueue = this.ringSyncQueue.then(() => this.syncRingVariant(optionValues, input, revision)).catch(() => {
            if (revision === this.ringSyncRevision) { this.ringVariantPending = false; this.ringVariantReady = false; this.updateState(); }
          });
        }
        this.updateState();
      };

      syncRingVariant = async (optionValues, fallbackInput, revision) => {
        if (typeof this.variantPicker?.selectCombination === 'function') await this.variantPicker.selectCombination({ optionValues, productChange: false });
        else fallbackInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (revision === this.ringSyncRevision) { this.ringVariantPending = false; this.ringVariantReady = true; this.updateState(); }
      };

      publishRingSelection() {
        const one = this.querySelector('[data-job-ring-stone="one"]');
        const two = this.querySelector('[data-job-ring-stone="two"]');
        const oneName = one?.value ? one.selectedOptions[0]?.textContent?.trim() || '' : '';
        const twoName = two?.value ? two.selectedOptions[0]?.textContent?.trim() || '' : '';
        this.updateOfferPreviews('ring', oneName, twoName);
        this.queueSecondRingVariant();
        if (!oneName && !twoName) return;
        this.dispatchEvent(new CustomEvent('jewel:birthstones-change', { bubbles: true, detail: { formId: this.formId, complete: Boolean(oneName && twoName), one: oneName, two: twoName } }));
      }

      publishSecondRingSelection() {
        const [one, two] = this.secondRingSelects.filter((select) => select.closest('.jewel-offer-builder__stone-grid'));
        const oneName = one?.value ? one.selectedOptions[0]?.textContent?.trim() || '' : '';
        const twoName = two?.value ? two.selectedOptions[0]?.textContent?.trim() || '' : '';
        this.updateOfferPreviews('second', oneName, twoName);
      }

      normalizePreviewValue(value) { return String(value || '').trim().toLowerCase(); }

      updateOfferPreviews(source, one, two) {
        const left = this.normalizePreviewValue(one);
        const right = this.normalizePreviewValue(two);
        this.querySelectorAll(`[data-job-offer-preview="${source}"]`).forEach((preview) => {
          const map = this.previewStoneMaps[preview.dataset.previewFinish] || {};
          if (left) this.applyPreviewStone(preview.querySelector('[data-job-preview-stone="left"]'), 'left', map[left]);
          if (right) this.applyPreviewStone(preview.querySelector('[data-job-preview-stone="right"]'), 'right', map[right]);
        });
      }

      applyPreviewStone(image, targetSide, stone) {
        if (!image || !stone?.url) return;
        image.src = stone.url;
        image.style.filter = stone.filter || 'none';
        image.classList.toggle('is-mirrored', stone.sourceSide !== targetSide);
        image.hidden = false;
      }

      updateSecondPreviewFinish() {
        this.querySelectorAll('[data-job-offer-preview="second"]').forEach((preview) => {
          preview.hidden = preview.dataset.previewFinish !== this.secondRingFinish;
        });
      }

      onSecondRingChange = () => { this.publishSecondRingSelection(); this.queueSecondRingVariant(); this.updateState(); };

      onFinishChange = (event) => {
        const button = event.currentTarget;
        this.secondRingFinish = button.dataset.jobBraceletFinish;
        this.finishButtons.forEach((item) => { const selected = item === button; item.classList.toggle('is-selected', selected); item.setAttribute('aria-pressed', String(selected)); });
        const label = this.querySelector('[data-job-bracelet-finish-name]');
        if (label) label.textContent = button.getAttribute('aria-label') || this.secondRingFinish;
        this.updateSecondPreviewFinish();
        this.queueSecondRingVariant();
        this.updateState();
      };

      queueSecondRingVariant() {
        const one = this.querySelector('[data-job-ring-stone="one"]');
        const two = this.querySelector('[data-job-ring-stone="two"]');
        const oneName = one?.value ? one.selectedOptions[0]?.textContent?.trim() : '';
        const twoName = two?.value ? two.selectedOptions[0]?.textContent?.trim() : '';
        this.secondRingPending = false;
        this.secondRingVariant = null;
        if (this.offerMode !== 'duo' || !oneName || !twoName) return;
        this.secondRingVariant = (this.giftVariants[this.secondRingFinish] || []).find(v => v.option1 === oneName && v.option2 === twoName) || null;
        const caption = this.querySelector('[data-job-matching-stones]');
        if (caption) caption.textContent = oneName + ' + ' + twoName + ' · ' + (this.secondRingFinish === 'silver' ? 'Silver' : 'Gold');
        const image = this.secondRingVariant?.featured_image?.src;
        if (image) this.querySelectorAll('.jewel-set-offer__gift-image, .jewel-set-offer__bracelet-image').forEach(el => { el.src = image; el.removeAttribute('srcset'); });
      }

      onVisualTrigger = (event) => {
        const dropdown = event.currentTarget.closest('[data-job-visual-dropdown]');
        const willOpen = event.currentTarget.getAttribute('aria-expanded') !== 'true';
        this.closeVisualDropdowns(dropdown);
        event.currentTarget.setAttribute('aria-expanded', String(willOpen));
        const menu = dropdown?.querySelector('[data-job-visual-menu]');
        if (menu) menu.hidden = !willOpen;
      };

      onVisualOption = (event) => {
        const option = event.currentTarget;
        const dropdown = option.closest('[data-job-visual-dropdown]');
        const select = dropdown?.querySelector('[data-job-visual-select]');
        if (!select || !option.dataset.value) return;
        select.value = option.dataset.value;
        dropdown.querySelectorAll('[data-job-visual-option]').forEach((item) => item.setAttribute('aria-selected', String(item === option)));
        const label = dropdown.querySelector('[data-job-selected-label]');
        if (label) label.textContent = option.dataset.label || '';
        const swatch = dropdown.querySelector('[data-job-selected-swatch]');
        if (swatch) {
          const imageUrl = option.dataset.imageUrl || '';
          swatch.style.backgroundImage = imageUrl ? `url(${JSON.stringify(imageUrl)})` : '';
          swatch.style.setProperty('--job-stone-color', option.dataset.stoneColor || '#8D1821');
          swatch.classList.toggle('jewel-offer-builder__stone-swatch--fallback', !imageUrl);
          swatch.hidden = false;
        }
        this.closeVisualDropdowns();
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };

      onOutsideClick = (event) => { if (!this.contains(event.target)) this.closeVisualDropdowns(); };
      onDocumentKeydown = (event) => { if (event.key === 'Escape') this.closeVisualDropdowns(); };
      closeVisualDropdowns(except = null) {
        this.visualDropdowns.forEach((dropdown) => {
          if (dropdown === except) return;
          dropdown.querySelector('[data-job-visual-trigger]')?.setAttribute('aria-expanded', 'false');
          const menu = dropdown.querySelector('[data-job-visual-menu]');
          if (menu) menu.hidden = true;
        });
      }

      updateState() {
        const ringComplete = this.ringSelects.length > 0 && this.ringSelects.every((select) => Boolean(select.value));
        const duo = this.offerMode === 'duo';
        const secondComplete = Boolean(this.secondRingVariant);
        const secondReady = !duo || (secondComplete && !this.secondRingPending && Boolean(this.secondRingVariant?.available));
        const complete = ringComplete && this.ringVariantReady && !this.ringVariantPending && secondReady;
        this.dataset.selectionComplete = String(complete);
        this.dataset.addBracelet = String(duo && this.dataset.addSecondEnabled === 'true');
        this.dataset.braceletVariantId = this.secondRingVariant?.id || '';
        this.dataset.secondRingVariantId = this.secondRingVariant?.id || '';
        this.dataset.braceletFinish = this.secondRingFinish;
        this.dataset.secondRingFinish = this.secondRingFinish;
        this.dataset.buttonLabel = duo ? `Get my ring + FREE bracelet — ${this.dataset.offerPrice}` : `Add to cart — ${this.dataset.offerPrice}`;
        const property = this.querySelector('[data-job-bracelet-variant-property]');
        if (property) property.value = this.secondRingVariant?.id || '';
        this.dispatchEvent(new CustomEvent('jewel:offer-builder-change', { bubbles: true, detail: { formId: this.formId, complete, offerMode: this.offerMode, buttonLabel: this.dataset.buttonLabel, secondRingVariantId: this.secondRingVariant?.id || null, secondRingFinish: this.secondRingFinish } }));
      }

      startOfferTimer() {
        const duration = Math.max(60, Number(this.dataset.offerSeconds || 13620));
        const storageKey = 'monty-veria-duo-deadline';
        let deadline = Number(window.localStorage.getItem(storageKey) || 0);
        if (!deadline || deadline <= Date.now()) { deadline = Date.now() + duration * 1000; window.localStorage.setItem(storageKey, String(deadline)); }
        const render = () => {
          let remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
          if (remaining <= 0) { deadline = Date.now() + duration * 1000; window.localStorage.setItem(storageKey, String(deadline)); remaining = duration; }
          const hours = Math.floor(remaining / 3600);
          const minutes = Math.floor((remaining % 3600) / 60);
          const seconds = remaining % 60;
          const text = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
          this.querySelectorAll('[data-job-offer-timer]').forEach((element) => { element.textContent = text; });
        };
        render();
        this.offerTimerInterval = window.setInterval(render, 1000);
      }

      openGuide = () => this.dialog?.showModal();
      closeGuide = () => this.dialog?.close();
      onGuideBackdrop = (event) => { if (event.target === this.dialog) this.dialog.close(); };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jewel-size-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jewel-size-selector')) {
    customElements.define('jewel-size-selector', class extends HTMLElement {
      static choices = new Map();
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.formId = this.dataset.formId;
        this.dialog = this.querySelector('[data-jss-dialog]');
        this.inputs = [...this.querySelectorAll('input[data-option-position]')];
        const choice = this.constructor.choices.get(this.formId);
        this.inputs.forEach((input) => { input.checked = input.dataset.sizeLabel === choice?.label; });
        this.setComplete(Boolean(choice && !choice.pending));
        if (choice?.pending) this.startPendingTimeout();
        this.querySelector('[data-jss-open]').addEventListener('click', () => this.dialog.showModal(), options);
        this.querySelector('[data-jss-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.querySelectorAll('[data-jss-select-size]').forEach((button) => {
          button.addEventListener('click', () => {
            const input = this.inputs.find((item) => item.dataset.sizeLabel === button.dataset.jssSelectSize);
            if (!input) return;
            if (!input.checked) input.click();
            this.dialog.close();
          }, options);
        });
        this.addEventListener('change', (event) => {
          if (!this.inputs.includes(event.target)) return;
          this.constructor.choices.set(this.formId, { label: event.target.dataset.sizeLabel, pending: true });
          this.querySelector('[data-jss-selection-error]').hidden = true;
          this.setComplete(false);
          this.startPendingTimeout();
        }, options);
        document.addEventListener('variant:change', (event) => {
          if (event.detail?.formId === this.formId) this.confirmVariant(event.detail.variant);
        }, options);
        document.addEventListener('product:rerender', (event) => {
          if (event.target.getAttribute('id') !== this.formId) return;
          const picker = event.detail?.htmlFragment?.querySelector(`variant-picker[form-id="${CSS.escape(this.formId)}"] script[data-variant]`);
          if (picker) this.confirmVariant(JSON.parse(picker.textContent));
        }, { ...options, capture: true });
        queueMicrotask(() => this.publish());
      }
      disconnectedCallback() {
        this.controller?.abort();
        window.clearTimeout(this.pendingTimeout);
      }
      confirmVariant(variant) {
        const current = this.constructor.choices.get(this.formId);
        if (!current) return;
        if (variant && variant.options[Number(this.dataset.optionPosition) - 1] !== current.label) {
          current.pending = true;
          this.setComplete(false);
          this.startPendingTimeout();
          return;
        }
        window.clearTimeout(this.pendingTimeout);
        current.pending = false;
        this.setComplete(true);
      }
      setComplete(complete) {
        this.dataset.selectionComplete = String(complete);
        this.dataset.selectionPending = String(Boolean(this.constructor.choices.get(this.formId)?.pending));
        this.publish();
      }
      publish() {
        this.dispatchEvent(new CustomEvent('jewel:size-change', {
          bubbles: true, detail: { formId: this.formId, complete: this.dataset.selectionComplete === 'true' }
        }));
      }
      startPendingTimeout() {
        window.clearTimeout(this.pendingTimeout);
        this.pendingTimeout = window.setTimeout(() => {
          if (!this.constructor.choices.get(this.formId)?.pending) return;
          this.constructor.choices.delete(this.formId);
          this.inputs.forEach((input) => { input.checked = false; });
          this.setComplete(false);
          this.querySelector('[data-jss-selection-error]').hidden = false;
        }, 15000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["monty-bundle-v2-horizontal"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHorizontalBundle = (root) => {
      const selected = root.querySelector('[data-monty-bundle-horizontal-choice]:checked');
      const quantity = root.querySelector('[data-monty-bundle-horizontal-quantity]');
      if (!selected || !quantity) return;

      quantity.value = selected.value;
      const formId = root.dataset.productFormId;
      const form = formId ? document.getElementById(formId) : null;
      if (!form) return;

      form.querySelectorAll('[name="quantity"]').forEach((input) => {
        input.value = selected.value;
      });
    };

    const initializeAllHorizontalBundles = (scope = document) => {
      scope.querySelectorAll('[data-monty-bundle-horizontal]').forEach(initializeHorizontalBundle);
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-monty-bundle-horizontal-choice]')) return;
      const root = event.target.closest('[data-monty-bundle-horizontal]');
      if (root) initializeHorizontalBundle(root);
    });

    document.addEventListener('DOMContentLoaded', () => initializeAllHorizontalBundles());
    document.addEventListener('shopify:section:load', (event) => initializeAllHorizontalBundles(event.target));
    initializeAllHorizontalBundles();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["monty-bundle-v2-vertical"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeVerticalBundle = (root) => {
      const selected = root.querySelector('[data-monty-bundle-vertical-choice]:checked');
      const quantity = root.querySelector('[data-monty-bundle-vertical-quantity]');
      if (!selected || !quantity) return;

      quantity.value = selected.value;
      const formId = root.dataset.productFormId;
      const form = formId ? document.getElementById(formId) : null;
      if (!form) return;

      form.querySelectorAll('[name="quantity"]').forEach((input) => {
        input.value = selected.value;
      });
    };

    const initializeAllVerticalBundles = (scope = document) => {
      scope.querySelectorAll('[data-monty-bundle-vertical]').forEach(initializeVerticalBundle);
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-monty-bundle-vertical-choice]')) return;
      const root = event.target.closest('[data-monty-bundle-vertical]');
      if (root) initializeVerticalBundle(root);
    });

    document.addEventListener('DOMContentLoaded', () => initializeAllVerticalBundles());
    document.addEventListener('shopify:section:load', (event) => initializeAllVerticalBundles(event.target));
    initializeAllVerticalBundles();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["monty-bundle-v2"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeBundle = (root) => {
      const selected = root.querySelector('[data-monty-bundle-v2-choice]:checked');
      const quantity = root.querySelector('[data-monty-bundle-v2-quantity]');
      if (!selected || !quantity) return;

      quantity.value = selected.value;
      const formId = root.dataset.productFormId;
      const form = formId ? document.getElementById(formId) : null;
      if (!form) return;

      form.querySelectorAll('[name="quantity"]').forEach((input) => {
        input.value = selected.value;
      });
    };

    const initializeAllBundles = (scope = document) => {
      scope.querySelectorAll('[data-monty-bundle-v2]').forEach(initializeBundle);
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-monty-bundle-v2-choice]')) return;
      const root = event.target.closest('[data-monty-bundle-v2]');
      if (root) initializeBundle(root);
    });

    document.addEventListener('DOMContentLoaded', () => initializeAllBundles());
    document.addEventListener('shopify:section:load', (event) => initializeAllBundles(event.target));
    initializeAllBundles();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["monty-supersavings-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeSupersavings = (root) => {
      const selected = root.querySelector('[data-monty-supersavings-choice]:checked');
      const quantity = root.querySelector('[data-monty-supersavings-quantity]');
      if (!selected || !quantity) return;

      quantity.value = selected.value;
      const formId = root.dataset.productFormId;
      const form = formId ? document.getElementById(formId) : null;
      if (!form) return;

      form.querySelectorAll('[name="quantity"]').forEach((input) => {
        input.value = selected.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    const initializeAllSupersavings = (scope = document) => {
      scope.querySelectorAll('[data-monty-supersavings]').forEach(initializeSupersavings);
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-monty-supersavings-choice]')) return;
      const root = event.target.closest('[data-monty-supersavings]');
      if (root) initializeSupersavings(root);
    });

    document.addEventListener('DOMContentLoaded', () => initializeAllSupersavings());
    document.addEventListener('shopify:section:load', (event) => initializeAllSupersavings(event.target));
    initializeAllSupersavings();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-auniva"] && !Shopify.designMode) return;
  try {
    class MontyProductMediaCarousel extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.carousel = this.querySelector('media-carousel');
      this.thumbnailList = this.querySelector('.product-gallery__thumbnail-list');
      this.thumbnailButtons = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
      this.animationFrame = null;
      this.destinationIndex = null;
      this.savedSnapType = '';

      this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.move(-1), {
        signal: this.abortController.signal,
      });

      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.move(1), {
        signal: this.abortController.signal,
      });

      this.thumbnailButtons.forEach((button) => {
        button.addEventListener('click', () => this.goToIndex(Number(button.dataset.galleryIndex)), {
          signal: this.abortController.signal,
        });
      });

      this.carousel?.addEventListener('carousel:change', (event) => {
        if (this.destinationIndex !== null) {
          return;
        }

        this.updateThumbnails(event.detail.index);
      }, { signal: this.abortController.signal });

      this.carousel?.addEventListener('carousel:settle', (event) => {
        if (this.destinationIndex !== null) {
          return;
        }

        this.updateThumbnails(event.detail.index);
      }, { signal: this.abortController.signal });

      this.updateThumbnails(Number(this.carousel?.getAttribute('initial-index') || 0), false);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.stopAnimation();
    }

    move(offset) {
      if (!this.carousel) {
        return;
      }

      const visibleSlides = this.getVisibleSlides();
      if (visibleSlides.length < 2) {
        return;
      }

      const allSlides = Array.from(this.carousel.children);
      const destinationSlide = allSlides[this.destinationIndex];
      let currentIndex = visibleSlides.indexOf(destinationSlide);

      if (currentIndex < 0) {
        currentIndex = this.getClosestVisibleIndex(visibleSlides);
      }

      const nextIndex = (currentIndex + offset + visibleSlides.length) % visibleSlides.length;
      this.goToIndex(allSlides.indexOf(visibleSlides[nextIndex]));
    }

    getVisibleSlides() {
      return Array.from(this.carousel?.children || []).filter((slide) => !slide.hidden);
    }

    getClosestVisibleIndex(visibleSlides) {
      const scrollPosition = this.carousel.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      visibleSlides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - scrollPosition);
        if (distance < closestDistance) {
          closestIndex = index;
          closestDistance = distance;
        }
      });

      return closestIndex;
    }

    goToIndex(index) {
      const slides = Array.from(this.carousel?.children || []);
      const targetSlide = slides[index];

      if (!targetSlide || targetSlide.hidden) {
        return;
      }

      this.destinationIndex = index;
      this.updateThumbnails(index);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.finishAt(index, targetSlide.offsetLeft);
        return;
      }

      this.animateTo(index, targetSlide.offsetLeft);
    }

    animateTo(index, targetLeft) {
      this.stopAnimation();
      this.carousel.__smoothScrollAbort?.();

      const startLeft = this.carousel.scrollLeft;
      const maxScroll = Math.max(0, this.carousel.scrollWidth - this.carousel.clientWidth);
      const destination = Math.max(0, Math.min(maxScroll, targetLeft));
      const distance = destination - startLeft;

      if (Math.abs(distance) < 1) {
        this.finishAt(index, destination);
        return;
      }

      this.savedSnapType = this.carousel.style.scrollSnapType;
      this.carousel.style.scrollSnapType = 'none';
      const startedAt = performance.now();
      const duration = 280;

      const step = (now) => {
        const progress = Math.min(1, (now - startedAt) / duration);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        this.carousel.scrollLeft = startLeft + distance * easedProgress;

        if (progress < 1) {
          this.animationFrame = requestAnimationFrame(step);
          return;
        }

        this.animationFrame = null;
        this.carousel.style.scrollSnapType = this.savedSnapType;
        this.finishAt(index, destination);
      };

      this.animationFrame = requestAnimationFrame(step);
    }

    finishAt(index, destination) {
      this.carousel.scrollLeft = destination;

      if (typeof this.carousel.select === 'function') {
        this.carousel.select(index, { animate: false, force: true });
      }

      this.destinationIndex = null;
      this.updateThumbnails(index);
    }

    stopAnimation() {
      if (this.animationFrame !== null) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }

      if (this.carousel) {
        this.carousel.style.scrollSnapType = this.savedSnapType;
      }
    }

    updateThumbnails(index, animate = true) {
      this.thumbnailButtons?.forEach((button) => {
        button.setAttribute('aria-current', String(Number(button.dataset.galleryIndex) === index));
      });

      const selectedButton = this.thumbnailButtons?.find((button) => Number(button.dataset.galleryIndex) === index);
      if (!selectedButton || !this.thumbnailList) {
        return;
      }

      requestAnimationFrame(() => {
        const maxScroll = Math.max(0, this.thumbnailList.scrollWidth - this.thumbnailList.clientWidth);
        const centeredLeft = selectedButton.offsetLeft - (this.thumbnailList.clientWidth - selectedButton.offsetWidth) / 2;

        this.thumbnailList.scrollTo({
          left: Math.max(0, Math.min(maxScroll, centeredLeft)),
          behavior: animate ? 'smooth' : 'auto',
        });
      });
    }
  }

  if (!customElements.get('monty-product-media-carousel')) {
    customElements.define('monty-product-media-carousel', MontyProductMediaCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-bracelet"] && !Shopify.designMode) return;
  try {
    class MontyProductMediaCarousel extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.carousel = this.querySelector('media-carousel');
      this.thumbnailList = this.querySelector('.product-gallery__thumbnail-list');
      this.thumbnailButtons = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
      this.animationFrame = null;
      this.destinationIndex = null;
      this.savedSnapType = '';

      this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.move(-1), {
        signal: this.abortController.signal,
      });

      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.move(1), {
        signal: this.abortController.signal,
      });

      this.thumbnailButtons.forEach((button) => {
        button.addEventListener('click', () => this.goToIndex(Number(button.dataset.galleryIndex)), {
          signal: this.abortController.signal,
        });
      });

      this.carousel?.addEventListener('carousel:change', (event) => {
        if (this.destinationIndex !== null) {
          return;
        }

        this.updateThumbnails(event.detail.index);
      }, { signal: this.abortController.signal });

      this.carousel?.addEventListener('carousel:settle', (event) => {
        if (this.destinationIndex !== null) {
          return;
        }

        this.updateThumbnails(event.detail.index);
      }, { signal: this.abortController.signal });

      this.updateThumbnails(Number(this.carousel?.getAttribute('initial-index') || 0), false);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.stopAnimation();
    }

    move(offset) {
      if (!this.carousel) {
        return;
      }

      const visibleSlides = this.getVisibleSlides();
      if (visibleSlides.length < 2) {
        return;
      }

      const allSlides = Array.from(this.carousel.children);
      const destinationSlide = allSlides[this.destinationIndex];
      let currentIndex = visibleSlides.indexOf(destinationSlide);

      if (currentIndex < 0) {
        currentIndex = this.getClosestVisibleIndex(visibleSlides);
      }

      const nextIndex = (currentIndex + offset + visibleSlides.length) % visibleSlides.length;
      this.goToIndex(allSlides.indexOf(visibleSlides[nextIndex]));
    }

    getVisibleSlides() {
      return Array.from(this.carousel?.children || []).filter((slide) => !slide.hidden);
    }

    getClosestVisibleIndex(visibleSlides) {
      const scrollPosition = this.carousel.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      visibleSlides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - scrollPosition);
        if (distance < closestDistance) {
          closestIndex = index;
          closestDistance = distance;
        }
      });

      return closestIndex;
    }

    goToIndex(index) {
      const slides = Array.from(this.carousel?.children || []);
      const targetSlide = slides[index];

      if (!targetSlide || targetSlide.hidden) {
        return;
      }

      this.destinationIndex = index;
      this.updateThumbnails(index);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.finishAt(index, targetSlide.offsetLeft);
        return;
      }

      this.animateTo(index, targetSlide.offsetLeft);
    }

    animateTo(index, targetLeft) {
      this.stopAnimation();
      this.carousel.__smoothScrollAbort?.();

      const startLeft = this.carousel.scrollLeft;
      const maxScroll = Math.max(0, this.carousel.scrollWidth - this.carousel.clientWidth);
      const destination = Math.max(0, Math.min(maxScroll, targetLeft));
      const distance = destination - startLeft;

      if (Math.abs(distance) < 1) {
        this.finishAt(index, destination);
        return;
      }

      this.savedSnapType = this.carousel.style.scrollSnapType;
      this.carousel.style.scrollSnapType = 'none';
      const startedAt = performance.now();
      const duration = 280;

      const step = (now) => {
        const progress = Math.min(1, (now - startedAt) / duration);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        this.carousel.scrollLeft = startLeft + distance * easedProgress;

        if (progress < 1) {
          this.animationFrame = requestAnimationFrame(step);
          return;
        }

        this.animationFrame = null;
        this.carousel.style.scrollSnapType = this.savedSnapType;
        this.finishAt(index, destination);
      };

      this.animationFrame = requestAnimationFrame(step);
    }

    finishAt(index, destination) {
      this.carousel.scrollLeft = destination;

      if (typeof this.carousel.select === 'function') {
        this.carousel.select(index, { animate: false, force: true });
      }

      this.destinationIndex = null;
      this.updateThumbnails(index);
    }

    stopAnimation() {
      if (this.animationFrame !== null) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }

      if (this.carousel) {
        this.carousel.style.scrollSnapType = this.savedSnapType;
      }
    }

    updateThumbnails(index, animate = true) {
      this.thumbnailButtons?.forEach((button) => {
        button.setAttribute('aria-current', String(Number(button.dataset.galleryIndex) === index));
      });

      const selectedButton = this.thumbnailButtons?.find((button) => Number(button.dataset.galleryIndex) === index);
      if (!selectedButton || !this.thumbnailList) {
        return;
      }

      requestAnimationFrame(() => {
        const maxScroll = Math.max(0, this.thumbnailList.scrollWidth - this.thumbnailList.clientWidth);
        const centeredLeft = selectedButton.offsetLeft - (this.thumbnailList.clientWidth - selectedButton.offsetWidth) / 2;

        this.thumbnailList.scrollTo({
          left: Math.max(0, Math.min(maxScroll, centeredLeft)),
          behavior: animate ? 'smooth' : 'auto',
        });
      });
    }
  }

  if (!customElements.get('monty-product-media-carousel')) {
    customElements.define('monty-product-media-carousel', MontyProductMediaCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-veria-set"] && !Shopify.designMode) return;
  try {
    class MontyProductMediaCarousel extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.carousel = this.querySelector('media-carousel');
      this.thumbnailList = this.querySelector('.product-gallery__thumbnail-list');
      this.thumbnailButtons = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
      this.animationFrame = null;
      this.destinationIndex = null;
      this.savedSnapType = '';

      this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.move(-1), {
        signal: this.abortController.signal,
      });

      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.move(1), {
        signal: this.abortController.signal,
      });

      this.thumbnailButtons.forEach((button) => {
        button.addEventListener('click', () => this.goToIndex(Number(button.dataset.galleryIndex)), {
          signal: this.abortController.signal,
        });
      });

      this.carousel?.addEventListener('carousel:change', (event) => {
        if (this.destinationIndex !== null) {
          return;
        }

        this.updateThumbnails(event.detail.index);
      }, { signal: this.abortController.signal });

      this.carousel?.addEventListener('carousel:settle', (event) => {
        if (this.destinationIndex !== null) {
          return;
        }

        this.updateThumbnails(event.detail.index);
      }, { signal: this.abortController.signal });

      this.updateThumbnails(Number(this.carousel?.getAttribute('initial-index') || 0), false);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.stopAnimation();
    }

    move(offset) {
      if (!this.carousel) {
        return;
      }

      const visibleSlides = this.getVisibleSlides();
      if (visibleSlides.length < 2) {
        return;
      }

      const allSlides = Array.from(this.carousel.children);
      const destinationSlide = allSlides[this.destinationIndex];
      let currentIndex = visibleSlides.indexOf(destinationSlide);

      if (currentIndex < 0) {
        currentIndex = this.getClosestVisibleIndex(visibleSlides);
      }

      const nextIndex = (currentIndex + offset + visibleSlides.length) % visibleSlides.length;
      this.goToIndex(allSlides.indexOf(visibleSlides[nextIndex]));
    }

    getVisibleSlides() {
      return Array.from(this.carousel?.children || []).filter((slide) => !slide.hidden);
    }

    getClosestVisibleIndex(visibleSlides) {
      const scrollPosition = this.carousel.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      visibleSlides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - scrollPosition);
        if (distance < closestDistance) {
          closestIndex = index;
          closestDistance = distance;
        }
      });

      return closestIndex;
    }

    goToIndex(index) {
      const slides = Array.from(this.carousel?.children || []);
      const targetSlide = slides[index];

      if (!targetSlide || targetSlide.hidden) {
        return;
      }

      this.destinationIndex = index;
      this.updateThumbnails(index);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.finishAt(index, targetSlide.offsetLeft);
        return;
      }

      this.animateTo(index, targetSlide.offsetLeft);
    }

    animateTo(index, targetLeft) {
      this.stopAnimation();
      this.carousel.__smoothScrollAbort?.();

      const startLeft = this.carousel.scrollLeft;
      const maxScroll = Math.max(0, this.carousel.scrollWidth - this.carousel.clientWidth);
      const destination = Math.max(0, Math.min(maxScroll, targetLeft));
      const distance = destination - startLeft;

      if (Math.abs(distance) < 1) {
        this.finishAt(index, destination);
        return;
      }

      this.savedSnapType = this.carousel.style.scrollSnapType;
      this.carousel.style.scrollSnapType = 'none';
      const startedAt = performance.now();
      const duration = 280;

      const step = (now) => {
        const progress = Math.min(1, (now - startedAt) / duration);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        this.carousel.scrollLeft = startLeft + distance * easedProgress;

        if (progress < 1) {
          this.animationFrame = requestAnimationFrame(step);
          return;
        }

        this.animationFrame = null;
        this.carousel.style.scrollSnapType = this.savedSnapType;
        this.finishAt(index, destination);
      };

      this.animationFrame = requestAnimationFrame(step);
    }

    finishAt(index, destination) {
      this.carousel.scrollLeft = destination;

      if (typeof this.carousel.select === 'function') {
        this.carousel.select(index, { animate: false, force: true });
      }

      this.destinationIndex = null;
      this.updateThumbnails(index);
    }

    stopAnimation() {
      if (this.animationFrame !== null) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }

      if (this.carousel) {
        this.carousel.style.scrollSnapType = this.savedSnapType;
      }
    }

    updateThumbnails(index, animate = true) {
      this.thumbnailButtons?.forEach((button) => {
        button.setAttribute('aria-current', String(Number(button.dataset.galleryIndex) === index));
      });

      const selectedButton = this.thumbnailButtons?.find((button) => Number(button.dataset.galleryIndex) === index);
      if (!selectedButton || !this.thumbnailList) {
        return;
      }

      requestAnimationFrame(() => {
        const maxScroll = Math.max(0, this.thumbnailList.scrollWidth - this.thumbnailList.clientWidth);
        const centeredLeft = selectedButton.offsetLeft - (this.thumbnailList.clientWidth - selectedButton.offsetWidth) / 2;

        this.thumbnailList.scrollTo({
          left: Math.max(0, Math.min(maxScroll, centeredLeft)),
          behavior: animate ? 'smooth' : 'auto',
        });
      });
    }
  }

  if (!customElements.get('monty-product-media-carousel')) {
    customElements.define('monty-product-media-carousel', MontyProductMediaCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
